import React from 'react'
import { Box, Typography } from '@mui/material'

import DataTable from '../../../components/table/DataTable'
import { formatCapturedPrice } from './posTaskReportShared'

const OWN_PRODUCT_COLUMNS = [
  { key: 'product_db_ref', label: 'CÓDIGO' },
  { key: 'barcode', label: 'COD. DE BARRA' },
  { key: 'product_name', label: 'NOMBRE DEL PRODUCTO' },
  { key: 'package_unit', label: 'EMPAQUE' },
  { key: 'price', label: 'PRECIO CAPTURADO' }
]

const COMPETITION_PRODUCT_COLUMNS = [
  { key: 'product_name', label: 'NOMBRE DEL PRODUCTO' },
  { key: 'package_unit', label: 'EMPAQUE' },
  { key: 'price', label: 'PRECIO CAPTURADO' }
]

const SECTION_TITLE_SX = {
  fontSize: 14,
  fontWeight: 700,
  mb: 1.25
}

const mapPriceRows = (products = [], prefix) =>
  products.map((product, index) => ({
    id: product.id || `${prefix}-${product.product_db_ref || product.product_name || index}`,
    product_db_ref: product.product_db_ref || '-',
    barcode: product.product_barcode || product.product_db_ref || '-',
    product_name: product.product_name || '-',
    package_unit: product.package_unit || '-',
    price: formatCapturedPrice(product)
  }))

export default function PosTaskPriceCaptureReport({ activity }) {
  const ownProducts = (activity.details || []).filter((product) => product.own)
  const competitionProducts = (activity.details || []).filter((product) => !product.own)

  if (ownProducts.length === 0 && competitionProducts.length === 0) {
    return null
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      {ownProducts.length > 0 && (
        <Box>
          <Typography sx={SECTION_TITLE_SX}>Detalles de producto(s) propio(s)</Typography>
          <DataTable
            compact
            ariaLabel="Detalles de productos propios"
            columns={OWN_PRODUCT_COLUMNS}
            rows={mapPriceRows(ownProducts, 'own')}
          />
        </Box>
      )}

      {competitionProducts.length > 0 && (
        <Box>
          <Typography sx={SECTION_TITLE_SX}>Detalles de producto(s) de competencia</Typography>
          <DataTable
            compact
            ariaLabel="Detalles de productos de competencia"
            columns={COMPETITION_PRODUCT_COLUMNS}
            rows={mapPriceRows(competitionProducts, 'competition')}
          />
        </Box>
      )}
    </Box>
  )
}
